<script setup>
defineProps({
    links: {
        type: Array,
        required: true,
    },
});
</script>
<script>
export default {
    name: 'LinkListDisplay',
};
</script>
<template>
    <ul class="list-disc">
        <li v-for="link in links" :key="link.id">
            <a :href="link.url" class="text-indigo-500">
                {{ link.title ?? link.url }}
            </a>
        </li>
    </ul>
</template>
